import { ServiceGlobal } from './service.global';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';
import { API } from '../../config/api';
import { Timestamp } from 'rxjs';

const CACHE_MAX_AGE_MILLISECONDS = 5 * 60 * 1000;
let cachedData: Promise<any> | null = null;
let cachedDataDate: Date | null = null;
function getCachedData(): Promise<any> | null {
    if (!cachedData) {
        return cachedData;
    }
    return cachedData.then((data) => {
        return JSON.parse(JSON.stringify(data));
    })
}

@Injectable()
export class StudentQuestionnaireService extends ServiceGlobal {

    sequence: any;
    name_alpha: any = 'student_questionnaire_id';
    api_find_one: any = 'student_questionnaires';
    api_find_all_default: any = 'student_questionnaires/?$orderby=student_name&$orderby=time_period';
    api_find_all: any = 'student_questionnaires';
    api_delete: any = 'student_questionnaires';
    loading: any = false;
    primary_key: any = 'student_questionnaire_id';
    tableName() { return 'student_questionnaires'; }

    student_questionnaire_id: string;
    school_id: string;
    academic_year_id: string;
    time_period: string;
    date: Date;
    class_number: string;
    student_code: string;
    group_id: string;

    attributeLabels() {
        return Object.assign(super.attributeLabels(), {
            "student_questionnaire_id": "Student Questionnaire",
            "createddate": "Date Created",
            "lastmoddate": "Date Last Modified",
            "created_by": "Created By",
            "modified_by": "Modified By",
            "student_questionnaire_template": "Student Questionnaire Template ID",
            "school_id": "School",
            "school_code": "School",
            "academic_year_id": "Academic Year",
            "time_period": "Time Period",
            "date": "Date",
            "form_class": "Form/Class",
            "class_number": "Class Number",
            "student_id": "Student ID",
            "student_code": "Student Code",
            "student_name": "Name",
            "category": "Category",
            "question_1": "Q1",
            "question_2": "Q2",
            "question_3": "Q3",
            "question_4": "Q4",
            "question_5": "Q5",
            "question_6": "Q6",
            "question_7": "Q7",
            "question_8": "Q8",
            "question_9": "Q9",
            "question_10": "Q10",
        });
    }

    save(update = false) {
        cachedData = null;
        cachedDataDate = null;
        var link = API.STUDENT_QUESTIONNAIRES;
        let attrs = this.getAttributes();

        if (update) {
            attrs = this.getAttributesUpdate();
            // attrs['student_id'] = this.getAttributes()['student_id'];
            link += '/' + attrs['student_questionnaire_id'];
            delete attrs['student_questionnaire_id'];
            attrs['date'] = Date.parse(attrs['date']);
            return this._db.put(link, attrs);
        }

        attrs['date'] = Date.parse(attrs['date']);
        attrs['student_questionnaire_template'] = 'b6f26f4f-f099-11ed-a24a-06ef1ef4c9ea';



        return  this._db.post(link, attrs);
    }

    rule() {
        return Object.assign(super.rule(), {
            "student_questionnaire_id": {
                "type": "string",
                "primary_key": true,
                "size": 36
            },
            "student_questionnaire_template": {
                "type": "string",
                "size": 36
            },
            "school_id": {
                "type": "string",
                "size": 36,
                "search": true
            },
            "school_code": {
                "type": "string",
                "size": 20,
                "search": true
            },
            "academic_year_id": {
                "type": "string",
                "size": 36,
                "search": true
            },
            "time_period": {
                "type": "string",
                "size": 191,
                "search": true
            },
            "date": {
                "type": "date"
            },
            "form_class": {
                "type": "string",
                "size": 191,
                "search": {
                    "op": "in"
                }
            },
            "class_number": {
                "type": "string",
                "size": 191
            },
            "student_id": {
                "type": "string",
                "size": 36
            },
            "student_code": {
                "type": "string",
                "size": 20,
                "search": {
                    "op": "in"
                }
            },
            "student_name": {
                "type": "string",
                "size": 40
            },
            "category": {
                "type": "string",
                "size": 40,
                "search": true
            },
        });
    }

  findAll(condition: any = {}, limit: number = 0, offset: number = 0) {
    const that = this;
    if (limit) {
      condition['$top'] = limit;
    }
    if (offset) {
      condition['$skip'] = offset;
    }
    condition['$expand'] = 'student_questionnaire_answers';
    let url = '';
    if (condition.hasOwnProperty('$orderby')) {
        url = this.api_find_all;
    } else {
        url = this.api_find_all_default;
    }
    return this._db.get(API.API_URL_COMMON + url, condition).then(rs => {
      if (rs) {
        for (const item of rs) {
          item.alpha = (item[that.name_alpha] && item[that.name_alpha][0]) ? item[that.name_alpha][0].toLowerCase() : '';
          item.id = item[that.primary_key];
        }
        return rs;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/student-questionnaire.service.ts